export const promote = (config) => ({ ...config });
//# sourceMappingURL=call-handoff-1-to-2.js.map